<template>
	<div id="typeform" class="typeform-widget">
	<!-- <transition name="slide-down"> -->
		<div
			class="target-dom-node"
			:style="`width: 100%; height: ${
				active && !alreadyAnswerd
					? $mq.isDesktop()
						? this.height
						: '200px' 
					: '0px'
			};`" 
		/> 
	<!-- </transition> -->
	</div>
</template>

<script>

import { scrollToElementId, scrollToTop } from '../../assets/js/main'

export default {

	data () {
		return {
			active: false,
			alreadyAnswerd: false
		}
	},

	props: {
		typeFormUrl: {
			type: String,
			default: null
		},
		autoscroll: {
			type: Boolean,
			default: true
		},
		height: {
			type: String,
			default: '620px'
		}
	},

	computed: {
		
	},

	methods: {
		open() {
			if (this.$mq.isWV()) return
			this.active = true
			if (!this.alreadyAnswerd && this.autoscroll) scrollToElementId('typeform')
		},

		close() {
			this.active = false
		},

		startScript () {

			if (!this.typeFormUrl) return
			var self = this

			const embedElement = document.querySelector('.target-dom-node') // NOTE: `.target-dom-node` is the target DOM element from your website or web app

			typeformEmbed.makeWidget(
			  embedElement,
			  this.typeFormUrl, // NOTE: Replace with your typeform URL
			  {
			    hideHeaders: true,
			    hideFooter: true,
			    opacity: 50,
			    buttonText: "Take the survey!",
			    onSubmit: function () {
			      self.active = false
			      self.alreadyAnswerd = true
			      scrollToTop()
			      self.onSubmit()
			    }
			  }
			)
		},

		onSubmit () {
			this.$emit('onSubmit')
		}
	},

	mounted () {
		this.startScript()
	}
}

</script>

<style scoped>
	.typeform-widget {
		margin-bottom: 40px;
	}
</style>
